export default {
    blue: {
        text: 'Голубой',
        value: {
            bg: '#E1EBF7',
            icon: '#ADC3E0',
            trigger: '#507FC2',
            text: '#2461B8'
        }
    },
    brown: {
        text: 'Коричневый',
        value: {
            bg: '#ECE5D8',
            icon: '#D8CCBA',
            trigger: '#B19A81',
            text: '#8D6A4C'
        }
    },
    green: {
        text: 'Зеленый',
        value: {
            bg: '#EDFFF0',
            icon: '#C2DFCF',
            trigger: '#4F9675',
            text: '#13815B'
        }
    },
    khaki: {
        text: 'Хаки',
        value: {
            bg: '#E7E4DA',
            icon: '#C7C6B7',
            trigger: '#88897A',
            text: '#6C6E4D'
        }
    },
    red: {
        text: 'Красный',
        value: {
            bg: '#FAF1ED',
            icon: '#E4C1C6',
            trigger: '#C45154',
            text: '#B02F3B'
        }
    },
    violet: {
        text: 'Фиолетовый',
        value: {
            bg: '#E9E6F4',
            icon: '#C7C4E4',
            trigger: '#8F8FC8',
            text: '#645CC5'
        }
    },
    yellow: {
        text: 'Желтый',
        value: {
            bg: '#FFFBE9',
            icon: '#F8EBB0',
            trigger: '#EACB3D',
            text: '#A18200'
        }
    }
};
